import retrieveAvailableAgreements from './retrieve-available-agreements';
import retrieveAvailableQuestions from './retrieve-available-questions';
import retrieveSelectedQuestions from './retrieve-selected-questions';
import answerSecurityQuestion from './answer-security-question';
import resolveCreatePassword from './resolve-create-password';
import resolveResetPassword from './resolve-reset-password';
import resolveSetSecurityQuestions from './resolve-set-security-questions';
import resolveEula from './resolve-eula';

export default function configureRequirementServices() {
    return [
        retrieveAvailableAgreements(),
        retrieveAvailableQuestions(),
        retrieveSelectedQuestions(),
        answerSecurityQuestion(),
        resolveCreatePassword(),
        resolveResetPassword(),
        resolveSetSecurityQuestions(),
        resolveEula(),
    ];
}
